<template>
  <div class="card"
    :class="laisserEnPlaceState ? 'min-width-60vw' : 'min-width-700'">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
      <error-msg-component :messages="msgErrorLaisserEnPlace" class="mgt-20px"
                           :error="errorLaisserEnPlace"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="errorLaisserEnPlace = $event"/>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <b-icon v-if="!laisserEnPlaceState"
              type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
            <h1 class="title is-size-3">
              {{ laisserEnPlaceState
                ? $t('gestionAffectation.popUpPreventionLaisserEnPlace.titleAdd')
                : $t('gestionAffectation.popUpPreventionLaisserEnPlace.titleRemove') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content pdl-0 pdr-0">
        <message-warning-tfs :tfsWithWarning="tfsWithWarning"
          @close="closeMessage"></message-warning-tfs>
        <div class="column is-12 is-paddingless mgv-20px" v-if="laisserEnPlaceState">
          <qd-switch v-model="lpVente" >
            {{$t('gestionAffectation.popUpPreventionLaisserEnPlace.laisserEnPlaceVente')}}
          </qd-switch>
        </div>
        <footer>
          <div class="has-text-centered">
            <button
                class="button btn-modal-annuler is-cancel has-text-centered button-modal"
                @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </button>
            <button class="button is-primary has-text-centered button-modal"
                    @click="setLaisserEnPlace">
            {{ $t('general.button.valider') }}
            </button>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import searchTfsWithWarning from '@/services/affectation/searchTfsWithWarning';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { affecterLaisserEnPlaceAsync } from '@/api/logistique/tourneeFaceSemaine';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/logistique/faceDisponible/validationFaceDisponible';
import messageWarningTfs from './messageWarningTfs';

export default {
  name: 'p_laisserEnPlace',
  props: {
    tfsSelectionnes: {
      type: Array,
      required: true,
    },
    anneeSemaine: {
      type: Number,
      required: true,
    },
    laisserEnPlaceState: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    messageWarningTfs,
    errorMsgComponent,
  },
  data() {
    return {
      tfsWithWarning: [],
      openDetail: false,
      lpVente: false,
      errorLaisserEnPlace: false,
      msgErrorLaisserEnPlace: [],
    };
  },
  methods: {
    async setLaisserEnPlace() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let tfs = [];
        if (this.laisserEnPlaceState) {
          this.tfsSelectionnes.forEach((tfs) => {
            const findFace = this.tfsWithWarning.find((f) => f.codeFace === tfs.produitReference);
            if (findFace) tfs.selected = findFace.selected;
          });
          tfs = this.tfsSelectionnes.filter(el => el.selected);
        } else tfs = this.tfsSelectionnes;
        await affecterLaisserEnPlaceAsync({
          laisseEnPlace: this.laisserEnPlaceState,
          ids: tfs.map((el) => { return el.id; }),
          laisserEnPlaceVente: this.lpVente,
        });
        if (this.laisserEnPlaceState) {
          messageSucces(this.$i18n.t('gestionAffectation.popUpPreventionLaisserEnPlace.successAdd'));
        } else {
          messageSucces(this.$i18n.t('gestionAffectation.popUpPreventionLaisserEnPlace.successRemove'));
        }
        this.$emit('apply');
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          this.errorLaisserEnPlace = true;
          this.msgErrorLaisserEnPlace = [];
          validation(e.response, this.msgErrorLaisserEnPlace);
        } else messageErreur(this.$i18n);
        throw e;
      }
    },
    closeMessage() {
      this.tfsWithWarning = [];
    },
    async loadMessageWarning() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.tfsWithWarning = await searchTfsWithWarning(this.tfsSelectionnes,
          this.anneeSemaine);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    if (this.laisserEnPlaceState) await this.loadMessageWarning();
  },
};
</script>

<style scoped>

</style>
